import React, { useState, useCallback, useContext, useEffect } from 'react';

import {
  CheckCircleOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  SaveOutlined,
} from '@ant-design/icons';

import NovoContext from '../NovoContext';
import S from './styles';

const steps = [
  {
    order: 0,
    title: 'Escolher Template',
    icon: <FileSearchOutlined />,
  },
  {
    order: 1,
    title: 'Informar Dados',
    icon: <FileTextOutlined />,
  },
  {
    order: 2,
    title: 'Finalizar',
    icon: <SaveOutlined />,
  },
];

function Steps() {
  const { rota, tipoRequest } = useContext(NovoContext);

  const [current, setCurrent] = useState(0);

  const doSetCurrent = () => {
    switch (rota) {
      case 'tipo-template':
        setCurrent(0);
        break;
      case 'informar-dados':
        setCurrent(1);
        break;
      case 'finalizar':
        setCurrent(2);
        break;
      default:
        setCurrent(0);
        break;
    }
  };

  const initialRender = useCallback(() => {
    doSetCurrent();
  }, [rota]); // eslint-disable-line

  useEffect(() => {
    initialRender();
  }, [initialRender]);

  function doStatus(order) {
    if (order === current) {
      return 'process';
    }
    if (order < current) {
      return 'finish';
    }
    return 'wait';
  }

  return (
    <S.Steps direction="vertical" current={current}>
      {steps.map((step) => (
        <S.Steps.Step
          key={step.order}
          status={doStatus(step.order)}
          title={step.title}
          icon={step.order < current ? <CheckCircleOutlined /> : step.icon}
          disabled={!step.order && tipoRequest === 'editar'}
        />
      ))}
    </S.Steps>
  );
}

export default Steps;
